"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const random_1 = require("../../../helpers/random");
const ErrorText_1 = require("../../atoms/ErrorText/ErrorText");
const Input_1 = require("../../atoms/Input/Input");
const Label_1 = require("../../atoms/Label/Label");
const Field = ({ value, onChange, label, id, optional, error, disabled, maxLength, className, type, placeholder, name, }) => {
    const fieldId = id || (0, random_1.randomString)();
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('flex flex-col gap-1', className) },
        react_1.default.createElement(Label_1.Label, { id: fieldId, optional: optional }, label),
        react_1.default.createElement(Input_1.Input, { value: value, onChange: onChange, error: !!error, id: fieldId, disabled: disabled, maxLength: maxLength, type: type, placeholder: placeholder, name: name }),
        error && typeof error === 'string' && react_1.default.createElement(ErrorText_1.ErrorText, { name: name }, error)));
};
exports.Field = Field;
